<template>
  <div class="chart_warp">
    <div class="chart_tool" v-if="false">
      <el-button class="def_btn tool_icon_btn" plain size="small" icon="el-icon-full-screen" :disabled="showEmpty"
        @click="fullScreen()">
      </el-button>
    </div>
    <PieGraphChart :ref="'graph_pie_' + chartName" :chart-name="chartName" :detail-type="chartName.split('-')[1]"
      @showFullChart="fullScreen" />
    <div class="empty_tips" v-if="showEmpty">暂无数据</div>
    <!-- 全屏显示图表 -->
    <el-dialog title="全景流通数字地图" custom-class="big_dialog" top="0" :visible.sync="fullVisible" :fullscreen="true"
      :modal="false" destroy-on-close>
      <FullGraphvisChart :ref="'graph_full_' + chartName" :chart-name="chartName"
        :detail-type="chartName.split('-')[1]" />
    </el-dialog>
  </div>
</template>

<script>
import PieGraphChart from './pieGraph.vue'
import FullGraphvisChart from './fullChartGraphvis.vue'

export default {
  components: {
    PieGraphChart,
    FullGraphvisChart
  },
  props: {
    detailInfo: [],
  },
  data() {
    return {
      chartName: '',
      fullVisible: false,
      showEmpty: false,
      simpleData: [],
      fullscreenLoading: false,
      pieGraphData: [],
    }
  },
  beforeDestroy() {
    this.$refs['graph_pie_' + this.chartName] && this.$refs['graph_pie_' + this.chartName].destroy();
    this.$refs['graph_full_' + this.chartName] && this.$refs['graph_full_' + this.chartName].destroy();
  },
  methods: {
    setOption(val) {
      if (val.node) {
        val.node.damId = val.damId
      }
      this.pieGraphData = val;
      let nodes = val.node ? [val.node] : []
      this.detailData = this.detailInfo
      this.simpleData = nodes
      this.currCenter = nodes[0]
      this.currNode = nodes[0]
      this.showEmpty = (val.labels && val.labels.length > 0) ? false : true
      if (this.showEmpty) return
      this.$nextTick(() => {
        this.$refs['graph_pie_' + this.chartName].setOption(this.pieGraphData)
      })
    },
    fullScreen(params) {
      this.fullVisible = true
      this.$nextTick(() => {
        this.$refs['graph_full_' + this.chartName].showVisGraph = true;
        this.$nextTick(() => {
          if (params) {
            this.$refs['graph_full_' + this.chartName].setOption(this.simpleData, params)
          } else {
            this.$refs['graph_full_' + this.chartName].setOption(this.simpleData, this.pieGraphData)
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.tips_empty {
  width: 100%;
  text-align: center;
  padding: 10px;
  background-color: #f2f2f2;
  color: #666;
}

.chart_warp {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .chart_tool {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;

    /deep/.el-button {
      position: absolute;
      right: 0;

      &.tool_icon_btn {
        right: unset;
        left: 0;
        padding: 0;
        width: 32px;
        height: 32px;

        i {
          font-size: 20px;
        }
      }
    }
  }

  .chart_cont {
    width: 100%;
    height: 100%;
  }

  .empty_tips {
    font-size: 20px;
    color: #909090;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
  }
}

/deep/.el-dialog {
  &__wrapper {
    overflow: hidden;
  }

  &.big_dialog {
    // height: calc(100% - 138px);
    margin: 0;
    // top: 138px;
    // float: right;

    .el-dialog__header {
      padding: 0 16px;
      line-height: 44px;
      text-align: center;

      .el-dialog__title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #212121;
        font-weight: 600;
      }

      .el-dialog__headerbtn {
        top: 15px;
      }
    }

    .el-dialog__body {
      padding: 0;
      width: 100%;
      height: calc(100% - 44px);
      overflow: hidden;

      .dialog_chart_warp {
        flex: 1;
        position: relative;
        transition: all 0.3s;
        background-color: #fff;
        overflow: hidden auto;

        .chart_tool {
          width: 100%;
          height: 44px;
          background-color: rgba(255, 255, 255, 0.85);
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 11;

          >span {
            display: block;
            padding: 0 12px;
            font-weight: 600;
            font-size: 16px;
            color: #212121;
            flex: 1;
          }

          >div {
            width: 290px;
            height: 100%;
            display: flex;
            align-items: center;

            .charts_btn {
              padding: 0 8px;
              color: #999;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              line-height: 22px;
              display: flex;
              align-items: center;
              cursor: pointer;

              >img {
                width: 14px;
                height: 14px;
                margin: 4px;
              }

              &:hover {
                // border-color: #999;
              }
            }
          }
        }

        .chart_cont_warp {
          width: 100%;
          height: 100%;
          // border-bottom: 1px solid #e5e5e5;
          overflow: hidden;
          position: relative;
        }

        &.full {
          width: 100%;
          // height: calc(100% - 45px);
          height: 100%;
          position: fixed;
          left: 0;
          bottom: 0
        }
      }

      .graph_tools_warp {
        border-top: 1px solid #E2E7EF;
        border-bottom: 1px solid #E2E7EF;
        display: flex;

        .tool_panel {
          +.tool_panel {
            border-left: 1px solid #E2E7EF;
          }
        }

        .big_title {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #212121;
          font-weight: 600;
          line-height: 44px;
          padding: 0 12px;
        }

        .tabs_thumbnail {
          padding: 0 12px 12px;
          display: flex;
          // flex-wrap: wrap;
          background-color: #fff;

          .tabs_group {
            width: 160px;
            text-align: center;

            +.tabs_group {
              margin-left: 12px;
            }

            .tabs_item {
              cursor: pointer;
              transition: all 0.3s;
              user-select: none;

              .tabs_img {
                height: 77px;
                background: #F7F9FC;
                display: flex;
                justify-content: center;
                align-items: center;

                >img {
                  width: calc(100% - 16px);
                  height: auto;
                  transition: width 0.3s;
                }
              }

              &:hover {
                box-shadow: 0 1px 1px 2px #E2E7EF;
              }

              &.disabled {
                cursor: not-allowed;

                &:hover {
                  box-shadow: none;
                }
              }

              &.active {
                box-shadow: 0 0 0 2px #46a5ff;

                &:hover {
                  box-shadow: 0 1px 1px 2px #46a5ff;
                }
              }

              &.disabled {
                cursor: not-allowed;

                .tabs_img {
                  background: #FAFAFA;
                }

                .tabs_tips {
                  background: #EFEFEF;
                  font-weight: 400;
                  color: #888;
                }

                &:hover {
                  border-color: transparent;
                }
              }
            }

            .tabs_tips {
              margin: 0;
              background: #E8EAF6;
              line-height: 33px;
              font-family: PingFangSC-Semibold;
              font-size: 14px;
              color: #262F40;
              font-weight: 600;
              background: #EBF5FF;
            }

            .tabs_btns {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 8px;

              .tabs_btn {
                height: 24px;
                line-height: 24px;
                background: #FFFFFF;
                border: 1px solid #d9d9d9;
                border-radius: 2px;
                cursor: pointer;

                &.col2 {
                  width: 74px;
                }

                &.col3 {
                  width: 46px;
                }

                &.disabled {
                  background: #EFEFEF;
                  border-color: #d9d9d9;
                  cursor: not-allowed;
                  color: #888;
                }

                &.active {
                  background: #46a5ff;
                  color: #fff;
                  border-color: #46a5ff;
                }
              }
            }
          }
        }
      }

      .chart_route {
        width: 219px;
        background-color: #fff;
        border-radius: 2px;
        border: 1px solid rgba(217, 217, 217, 1);
        position: absolute;
        left: -219px;
        top: 52px;
        z-index: 3;
        transition: left .3s;

        &.active {
          left: 12px;
        }

        .mini_view_panel {
          width: 100%;
          height: 170px;
          overflow: hidden;

          .side_icon {
            color: #fff;
            font-size: 18px;
            cursor: pointer;
          }

          .side_icon_show {
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background-color: rgba(0, 0, 0, 0.65);
            border-radius: 0 2px 2px 0;
            position: absolute;
            top: 0;
            right: -26px;
          }

          .side_icon_hide {
            width: 26px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background-color: transparent;
            position: absolute;
            top: 0;
            right: 0;
            z-index: 2;
          }

          .chart_img_panel {
            width: 100%;
            height: 100%;
            overflow: hidden;

            .panel_tool {
              height: 40px;
              padding: 0 12px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #5797FF;
              font-weight: 400;
              display: flex;
              align-items: center;
              cursor: pointer;
              box-shadow: 0 1px 0 0 #d9d9d9;

              .chart_title {
                display: block;
                width: 18px;
                height: 18px;
                color: #5797FF;
                margin-right: 8px;
                border: 2px solid #5797FF;
                border-radius: 18px;
                display: flex;
                justify-content: center;
                align-items: center;

                >i {
                  font-weight: bold;
                }
              }
            }

            .chart_img {
              height: calc(100% - 40px);
              display: flex;
              justify-content: center;
              align-items: center;
              overflow: hidden;

              >img {
                scale: 0.5;
              }
            }
          }
        }
      }

      .route_panel_warp {
        background-color: #fff;
        position: absolute;
        right: 12px;
        top: 52px;
        z-index: 3;

        .panel_title {
          padding: 0 12px;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          color: #212121;
          line-height: 44px;
          box-shadow: 0 0 0 1px #d9d9d9;
        }

        .route_group_panel {
          width: 240px;
          max-height: calc(100vh - 400px);
          box-shadow: 0 0 0 1px #d9d9d9;
          overflow: hidden auto;
          margin-top: 1px;

          &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
          }

          .route_group {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 0 10px 0 20px;
            position: relative;

            &::before {
              content: '';
              width: 9px;
              height: 9px;
              background-color: #ddd;
              border-radius: 9px;
              position: absolute;
              left: 5px;
              top: 16px;
              transform: translateY(-50%);
              z-index: 1;
            }

            &::after {
              content: '';
              height: 100%;
              width: 1px;
              background-color: #ddd;
              position: absolute;
              left: 9px;
              bottom: 0;
            }

            &:first-child {
              &::after {
                height: calc(100% - 15px);
              }
            }

            &+.route_group {
              &::before {
                top: 36px;
              }
            }

            &:last-child {
              &::before {
                background-color: #1890FF;
              }

              &::after {
                height: 36px;
                bottom: unset;
                top: 0;
              }
            }

            .route_slice {
              width: 100%;
              color: #909090;
              font-size: 12px;
              line-height: 20px;
              position: relative;
            }

            .route_text {
              width: 100%;
              color: #212121;
              line-height: 20px;
              padding: 5px 0;
              font-size: 12px;
              letter-spacing: 0;
              cursor: pointer;

              &:hover,
              &.active {
                color: #4162e8;
              }

              &.active {
                cursor: default;
              }
            }
          }
        }
      }

      .node_tabs_panel {
        // width: 278px;
        // padding: 10px;
        position: absolute;
        // top: 5px;
        // right: 5px;
        border: 1px solid #ddd;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .25);

        .node_tabs_list {
          &+.node_tabs_list {

            .tabs_group {
              border-top: 1px solid #ddd;
            }
          }

          .tabs_group {
            padding: 5px 0;
          }

          .tabs_item {
            padding: 0 15px;
            height: 26px;
            line-height: 26px;
            font-size: 12px;
            cursor: pointer;

            &:hover,
            &.active {
              background-color: #e0e0e0;
            }
          }
        }

        .list_group {
          .list_group_head {
            position: relative;

            .group_head_title {
              .head_title {
                display: flex;
                align-items: center;
                margin-bottom: 8px;
                font-size: 16px;

                .title_label {
                  width: 60px;
                  height: 20px;
                  line-height: 20px;
                  font-size: 12px;
                  color: #FF8831;
                  background: #FFF9F5;
                  border-radius: 10px;
                  margin-left: 10px;

                  img {
                    width: 20px;
                    height: 18px;
                    margin: -2px 2px 0 4px;
                    vertical-align: middle;
                  }
                }

                .title_text {
                  margin-right: 15px;
                }
              }

              .head_tags {
                .el-tag {
                  margin-right: 5px;
                }
              }
            }

            .group_head_tool {
              position: absolute;
              right: 0;
              top: 0;

              .panel_close_icon {
                font-size: 16px;
                color: #909090;
                cursor: pointer;

                &:hover {
                  color: rgba(0, 0, 0, 0.8);
                }
              }
            }
          }

          .list_group_body {
            padding: 8px 5px;
            font-size: 12px;

            .group_item {
              display: flex;
              color: #212121;
              height: 26px;
              align-items: center;

              .group_item_filed {
                width: 70px;
              }

              .group_item_value {
                color: #909090;
              }
            }
          }
        }

        .group_title {
          height: 25px;
          line-height: 25px;
          padding: 0 5px;
          color: #212121;
          background: #f2f2f2;
          font-weight: 400;
          font-size: 12px;
        }

        .panel_tool {
          display: flex;
          flex-wrap: wrap;
          margin-top: 15px;

          .tool_tirle {
            width: 90px;
          }

          .tool_bars {
            // width: calc(100% - 90px);
            width: 100%;
            display: flex;
            flex-wrap: wrap;

            .tool_bar {
              margin: 0 5px 5px 0;
              padding: 5px 12px;
              background-color: #fff;
              border-radius: 2px;
              border: 1px solid #ddd;
              color: #212121;
              cursor: pointer;

              &:hover,
              &.is-checked {
                border-color: #1890FF;
                color: #1890FF;
              }

              .el-checkbox__input {
                display: none;
              }

              .el-checkbox__label {
                padding-left: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
